import { Box, Checkbox, TeamAvatar, Typography, UserAvatar } from '@pocketlaw/tetris';
import { Container } from './styled';
export function RequiredApproverCard(props) {
    const { type, name, reasoning, selected, onChange } = props;
    const renderCheckbox = selected !== undefined;
    const handleChange = (event) => {
        onChange === null || onChange === void 0 ? void 0 : onChange(event.target.checked);
    };
    return (<Container>
      <Box alignItems="center" justifyContent="space-between">
        {type === 'user' ? <UserAvatar size="sm" title={name}/> : <TeamAvatar size="sm" title={name}/>}
        {renderCheckbox && (<Box mr="sm">
            <Checkbox checked={selected} onChange={handleChange}/>
          </Box>)}
      </Box>
      <Typography $fontSize="small" $appearance="200">
        {reasoning}
      </Typography>
    </Container>);
}
